import React from "react";

const CardFooter = (props) => {
    return (
        <div className={'card-footer'}>{''}</div>
    );
};

export default CardFooter;
